<template>
  <v-content class="pt-0">
    <v-flex xs12 md12>
      <v-form>
        <v-container class="grid-list-md">
          <h1>Aktualizacja danych</h1>

          <profile-form v-if="loaded" :$schema="$schema" />

          <v-card class="elevation-0 mb-3">
            <v-card-actions class="pb-4 pt-4">
              <v-btn depressed large dark round color="secondary" :to="{name: 'home'}">Powrót</v-btn>

              <v-btn depressed large dark round color="primary" @click="tryToUpdate">Zapisz</v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-form>
    </v-flex>
  </v-content>
</template>

<script>
import { mapState } from 'vuex';
import { schemaMixin } from '@witkac/vuetify-components';
import { ProfileType } from '@witkac/kartamiejska-shared';

import HeaderSimple from '@/components/layout/HeaderSimple';
import ProfileForm from '@/components/forms/ProfileForm';
import store from '@/store/store';
import schema from '@/schemas/edit.schema';
import { SessionStorage } from '@/enums/sessionStorage.enum';

export default {
  mixins: [schemaMixin],
  components: { HeaderSimple, ProfileForm },
  data() {
    return { model: {}, loaded: false };
  },
  schema,
  computed: mapState({ profile: state => state.profile }),
  methods: {
    tryToUpdate() {
      if (!this.$schema.$validateAll().length) {
        const id = parseInt(sessionStorage.getItem(SessionStorage.PROFILE_ID));
        this.$store
          .dispatch('profile/update', { ...this.model.profile, id })
          .then(() =>
            this.$store.dispatch('notifySuccess', {
              title: 'Zapisano zmiany w profilu.'
            })
          )
          .catch(() =>
            this.$store.dispatch('notifyError', {
              title: 'Nie udało się zapisać zmian w profilu.'
            })
          );
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    store.commit(
      'profile/setId',
      sessionStorage.getItem(SessionStorage.USER_ID)
    );
    store
      .dispatch('profile/get')
      .then(profile =>
        next(vm => {
          vm.$schema.$setData({ profile });
          vm.loaded = true;
        })
      )
      .catch(() =>
        store.dispatch('notifyError', {
          title: 'Nie udało się pobrać profilu.'
        })
      );
  }
};
</script>
